export default __webpack_public_path__ + "static/media/google-map.c180cfcc.jpg";